/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Product methods
 * -----------------------------------------------------------------------------
 *
 * @namespace product
 */
import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fullscreen';
import enquire from 'enquire.js';
import scrollMonitor from 'scrollmonitor';

var productMethods = {
  data: function data() {
    return {
      enableHistoryState: true,
      isProductToolbarMobileOpen: false,
      product: {},
      currentVariant: {},
      lawnVarId: '',
      trayVarId: '',
      trayShippingRate: '',
      currentActiveSubscription: null,
      ActiveSubscriptionMessage: false
    };
  },
  created: function created() {
    this.text = 'The component is now created';
    console.log('loaded');
    // eslint-disable-next-line radix
    if (document.querySelector('[data-bundle-subscription_custom]')) {
      // eslint-disable-next-line radix
      var pricee = parseInt(document.querySelector('[data-bundle-subscription_custom]').innerHTML);
      var subsPrice = (pricee / 100).toFixed(2);
      console.log(subsPrice, 'subsPricesubsPrice');
      if (document.querySelector('.cur_discount_price_custom')) {
        document.querySelector('.cur_discount_price_custom').innerHTML = "$" + subsPrice;
      }
    }
    if (document.querySelector('[data-bundle-regular_custom]')) {
      // eslint-disable-next-line radix
      var Regpricee = parseInt(document.querySelector('[data-bundle-regular_custom]').innerHTML);
      var regPrice = (Regpricee / 100).toFixed(2);
      console.log(regPrice, 'regPriceregPrice raman');
      setTimeout(function () {
        if (document.querySelector('.one-time-price_bundle')) {
          document.querySelector('.one-time-price_bundle').innerHTML = "$" + regPrice;
        }
      }, 100);
    }
  },


  methods: {

    /**
     * Product Single
     */
    _initProduct: function _initProduct() {
      var $container = $('[data-product-template]');
      var $productTabs = $(app.selectors.productTabs);
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      var productObj = app.selectors.productObj;

      // product tabs add active class to 1st child
      $productTabs.find('.nav-item').first().find('a').addClass('active');
      $productTabs.find('.tab-content .tab-pane').first().addClass('active');

      // stop parsing if we are not in the product template
      if (app.currentTemplate !== 'product') {
        return;
      }

      // set data
      app.product = JSON.parse($(productObj).html());
      var productData = JSON.parse($(productObj).html());
      app.product = productData.product;
      app.product.options_with_values = productData.options_with_values;
      app.product.tags = productData.tags;
      app.product.sub_meta = productData.sub_metafields;
      // assign the product cart limit
      app.product.tags.forEach(function (tag) {
        if (tag.match('cart-limit')) {
          var cartLimit = tag.replace('cart-limit-', '');
          app.product.cart_limit = parseFloat(cartLimit);
        }
      });

      app.enableHistoryState = $container.data('enable-history-state');
      app._customerHashID(app.customer.email);
      app._getVariant();
      // Recharge widget
      app._attachRechargeWidget(app.product.id);
      if (app.product.handle == 'doggielawn-bundle') {
        setTimeout(function () {
          $('.rc_option__recurring label').trigger('click');
        }, 1000);
      }
      $('body').on('change', function (e) {
        if (e.target.matches('[data-recharge-subscription-widget] input[type="radio"]')) {
          if (app.product.tags.indexOf('lawn') < 0 && app.customer.id !== '') {
            if ($('[data-recharge-subscription-widget] input[type="radio"]:checked').attr('id').includes('autodeliver_off')) {
              $('.cart-wrap button').text('Add to Cart');
              app.currentActiveSubscription = null;
              app.ActiveSubscriptionMessage = false;
            } else if ($('[data-recharge-subscription-widget] input[type="radio"]:checked').attr('id').includes('autodeliver_on')) {
              $('[data-rc_select__dropdown]').trigger('change');
              app.ActiveSubscriptionMessage = true;
            }
          }
          if (app.product.handle == 'doggielawn-bundle') {
            var size_cur = app._handleize(app.currentVariant.option1);

            if ($('[data-recharge-subscription-widget] input[type="radio"]:checked').attr('id').includes('autodeliver_off')) {
              $('[tray_text]').addClass('d-none');
            } else if ($('[data-recharge-subscription-widget] input[type="radio"]:checked').attr('id').includes('autodeliver_on')) {
              $('[data-rc_select__dropdown]').trigger('change');

              if (size_cur == 'xl-flex-tray' || size_cur == 'xl-plastic-tray') {
                $('[tray_text').addClass('d-none');
              } else {
                $('[tray_text').removeClass('d-none');
                if (size_cur == 'xl-grass-only') {
                  $('[tray_text').text('Tray not included. Easily skip shipments or cancel subscription at any time.').removeClass('d-none');
                } else {
                  $('[tray_text').text('Free reusable tray included with first shipment only. Easily skip shipments or cancel subscription at any time.').removeClass('d-none');
                }
              }
            }
          }
          //app._changeRechargeDisplayPrices();
        }
      });

      if (app.product.tags.indexOf('lawn') < 0 && app.customer.id !== '') {
        // only for addon products
        $('[data-rc_select__dropdown]').on('change', function (e) {
          app._getActiveSubscription(e);
          //app._changeRechargeDisplayPrices();
        });
      }

      function registerMobileToolbar() {
        var productFormPosition = $(app.selectors.productForm).position();
        var formWatcher = scrollMonitor.create($(app.selectors.productForm));
        var footerWatcher = scrollMonitor.create($('[data-footer-bottom]'));
        $productToolbarMobile.show();

        window.addEventListener('scroll', function () {
          var windowScrollY = window.scrollY;

          if (windowScrollY > productFormPosition.top) {
            formWatcher.exitViewport(function () {
              $productToolbarMobile.addClass('semi-opened');
            });

            formWatcher.enterViewport(function () {
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });

            footerWatcher.exitViewport(function () {
              $productToolbarMobile.addClass('semi-opened');
            });

            footerWatcher.enterViewport(function () {
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });
          } else {
            $productToolbarMobile.removeClass('semi-opened fully-opened');
            if (app.isProductToolbarMobileOpen) {
              app.isProductToolbarMobileOpen = false;
            }
          }
        }); // add scroll event listener
      }

      // mobile product form - sticky toolbar
      enquire.register('screen and (min-width: 720px)', {
        setup: function setup() {
          registerMobileToolbar();
        },
        match: function match() {
          $productToolbarMobile.hide();
        },
        unmatch: function unmatch() {
          registerMobileToolbar();
        }
      });
    },
    _changeRechargeDisplayPrices: function _changeRechargeDisplayPrices() {
      if (!$('[data-recharge-subscription-widget] input[type="radio"]').length) {
        return;
      }
      var per = parseFloat($('.rc_discount_percentage').text().split('%')[0]);
      var price = app.currentVariant.price / 100;
      var newPrice = price - price * (per / 100);
      if ($('[data-recharge-subscription-widget] input[type="radio"]:checked').attr('id').includes('autodeliver_off')) {
        setTimeout(function () {
          $('[data-product-price]').text(app._formatMoney(app.currentVariant.price));
        }, 200);
      } else {
        setTimeout(function () {
          $('[data-product-price]').text(app._formatMoney(newPrice * 100));
        }, 200);
      }
      if ($('.rc_discount_price').text() !== app._formatMoney(newPrice * 100)) {
        setTimeout(function () {
          $('.rc_discount_price').text(app._formatMoney(newPrice * 100));
        }, 50);
      }
    },


    /**
     * Event when product option select or input changes
     *
     */
    _getVariant: function _getVariant(event, price, mainPrice) {

      var variant = app._getVariantFromOptions(event);
      console.log(window.location.href.split('=')[1], 'eventtttttt');
      var discountedPrice = (price / 100).toFixed(2);
      var mainPricePDP = (mainPrice / 100).toFixed(2);
      console.log(discountedPrice, 'discountedPrice');
      console.log(mainPricePDP, 'mainPricePDP');

      // console.log(perDeliveryPrice, (perDeliveryPrice / 100).toFixed(2), comparePrice, (comparePrice / 100).toFixed(2), event.target, 'hahahahahahahahah');
      if (price !== undefined) {
        if (document.querySelector('.cur_discount_price_custom')) {
          // if (app.currentTemplate === 'product') {
          //   const selectedOption = event.target.selectedOptions[0];
          //   const perDeliveryPrice = selectedOption.getAttribute('perdeliveryprice');
          //   // const comparePrice = selectedOption.getAttribute('compareprice');
          //   document.querySelector('.cur_discount_price_custom').innerHTML = `$${perDeliveryPrice}`;
          // } else {
          // }
          // eslint-disable-next-line eqeqeq
          if (app.product.handle !== 'reusable-pee-pad') {
            document.querySelector('.cur_discount_price_custom').innerHTML = "$" + discountedPrice;
          }
        }
      }
      if (mainPricePDP !== undefined) {
        if (document.querySelector('.one-time-price_bundle')) {
          // if (app.currentTemplate === 'product') {
          //   const selectedOption = event.target.selectedOptions[0];
          //   // const perDeliveryPrice = selectedOption.getAttribute('perdeliveryprice');
          //   const comparePrice = selectedOption.getAttribute('compareprice');
          //   document.querySelector('.one-time-price_bundle').innerHTML = `$${comparePrice}`;
          // } else {
          // }
          // eslint-disable-next-line eqeqeq
          if (app.product.handle !== 'reusable-pee-pad') {
            document.querySelector('.one-time-price_bundle').innerHTML = "$" + mainPricePDP;
          }
          // document.querySelector('.one-time-price_bundle').innerHTML = `$${mainPricePDP}`;
        }
      }
      // if (price !== undefined) {
      //   this._getVariant(event, price);
      // }
      // stop parsing if there is no variant info
      if (!variant) {
        app.currentVariant = {};
        return;
      }

      app._updateImages(variant, event);

      if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        product.current_variant = variant;
      } else if (app.currentTemplate === 'product') {
        var var1, var2, size;
        app.currentVariant = variant;
        if (app.product.sub_meta != null) {
          app.currentVariant.discount_price = app.product.sub_meta[variant.id].discount_variant_price;
          $('.cur_discount_price').text('$' + app.currentVariant.discount_price);
        }

        size = app._handleize(app.currentVariant.option1);
        if (app.product.handle == "doggielawn-bundle") {
          if (size == 'xl-flex-tray' || size == 'xl-plastic-tray') {
            $('.rc_option__one-time label').trigger('click');
            $('.recharge-subscription').hide();
            $('[tray_text').text('').addClass('d-none');
          } else {
            $('.recharge-subscription').show();
            $('[tray_text').removeClass('d-none');
            if ($('.rc_option__recurring').hasClass('active')) {
              if (size == 'xl-grass-only') {
                $('[tray_text').text('Tray not included. Easily skip shipments or cancel subscription at any time.').removeClass('d-none');
              } else {
                $('[tray_text').text('Free reusable tray included with first shipment only. Easily skip shipments or cancel subscription at any time.').removeClass('d-none');
              }
            }

            if (size == 'xl-grass-only') {
              $('[tray_text').text('Tray not included. Easily skip shipments or cancel subscription at any time.').removeClass('d-none');
            } else {
              $('[tray_text').text('Free reusable tray included with first shipment only. Easily skip shipments or cancel subscription at any time.').removeClass('d-none');
            }
          }

          if (size != 'xl-grass-only') {
            if (size !== 'xl-flex-tray') {
              size = size.split('-');
              var1 = JSON.parse($('[data-bundle-prds][data-title="' + size[0] + '"][data-type="Tray"]').html().trim());
              var2 = JSON.parse($('[data-bundle-prds][data-title="' + size[0] + '"][data-type="Tray"]').html().trim());
            } else {
              var1 = JSON.parse($('[data-bundle-prds][data-title="xl"][data-type="Tray"]').html().trim()); // add xl lawn for flex tray as well
              var2 = JSON.parse($('[data-bundle-prds][data-title="xl"][data-type="Tray"]').html().trim());
            }
          } else {
            size = size.split('-');
          }
          // eslint-disable-next-line shopify/jquery-dollar-sign-reference
          // const scriptContent = document.querySelector('[data-bundle-subscription_custom]').innerHTML;
          // const products = JSON.parse(scriptContent);
          // const foundProduct = products.find((item) => item.id === window.location.href.split('=')[1]);
          // console.log(foundProduct, 'foundproduct');
          // const sellingPlanAllocation = foundProduct.selling_plan_allocations.find((allocation) => allocation.selling_plan_id === 3405283525);
          // const perDeliveryPrice = sellingPlanAllocation.per_delivery_price;
          // console.log('Per delivery price:', perDeliveryPrice);
          var subscription_bundle_product = $('[data-bundle-subscription][data-title="' + size[0] + '"][data-type="subscription"]');
          var subscription_bundle_price = subscription_bundle_product.attr('data-price');
          var subscription_bundle_subscription_price = subscription_bundle_product.attr('subscription-price');
          // $('.cur_discount_price').text(subscription_bundle_subscription_price);
          // $('.cur_discount_price_custom').text(perDeliveryPrice);
          // $('.cur_discount_price').text(subscription_bundle_price).attr('data-variant_id',subscription_bundle_product.attr('data-varId'));
          // eslint-disable-next-line radix
          var Regpricee = parseInt(document.querySelector('[data-bundle-regular_custom]').innerHTML);
          var regPrice = (Regpricee / 100).toFixed(2);
          // $('.one-time-price_bundle').text(`$${regPrice}`);
          console.log(app.currentVariant.discount_price, 'app.currentVariant.discount_price');
          var variantData = JSON.parse($('[data-bundle-subscription]').html());
          // app.product = productData.product;
          // app.product.options_with_values = productData.options_with_values;
          // app.product.tags = productData.tags;
          // app.product.sub_meta = productData.sub_metafields;
          // size = app._handleize(app.currentVariant.option1);
          // if (size !== 'xl-flex-tray') {
          //   size = size.split('-');
          //   var2 = JSON.parse($('[data-bundle-prds][data-title="'+size[0]+'"][data-type="Tray"]').html().trim());
          // } else {
          //   var2 = JSON.parse($('[data-bundle-prds][data-title="xl"][data-type="Tray"]').html().trim()); // add xl lawn for flex tray as well
          // }
          // console.log(var1);
          // var2 = JSON.parse($('[data-bundle-prds][data-title="'+size+'"][data-type="Tray"]').html().trim());

          if (var1 != undefined) {
            app.lawnVarId = var1;
          }
          if (var2 != undefined) {
            app.trayVarId = var2;
          }
        } else if (app.product.handle == "doggielawn") {
          var1 = JSON.parse($('[data-bundle-prds][data-title="' + size + '"][data-type="DoggieLawn"]').html().trim());
          if (var1 != undefined) {
            app.lawnVarId = var1;
          }
        } else if (app.product.handle == "doggielawn-tray") {
          var2 = JSON.parse($('[data-bundle-prds][data-title="' + size + '"][data-type="Tray"]').html().trim());
          if (var2 != undefined) {
            app.trayVarId = var2;
            var shipRate = var2.tags.filter(function (tag) {
              return tag.indexOf('fixedshipping') > -1;
            });
            app.trayShippingRate = shipRate[0];
          }
          var cur_title = app.currentVariant.title.toLowerCase().replace(/\s+/g, '-');
          $('.product-description').html($(app.product.description).find('.' + cur_title).html());
        } else if (app.product.handle == "disposable-doggielawn") {

          $('[data-disposable-pr]').removeClass('active');

          var subscription_dis_product = $('[data-disposable-pr][product-title="' + size + '"][data-type="disposable"]');
          var subscription_dis_price = subscription_dis_product.attr('data-price');
          $('.cur_discount_price').text(subscription_dis_price);
          subscription_dis_product.addClass('active');
          //$('.one-time-price_bundle').text('$'+app.currentVariant.discount_price)
        }
        if (app.enableHistoryState) {
          app._updateHistoryState(variant);
        }

        // ReCharge Integration for the product page
        // Update data needed for ReCharge when variant changes
        var discountVariantId = $("[data-variant-id=\"" + variant.id + "\"]").attr('data-discount-variant-id');
        app.reChargeDiscountVariantId = discountVariantId;
        //app._changeRechargeDisplayPrices();
      }
    },


    /**
     * Get the currently selected options from add-to-cart form.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions(event) {
      var singleOptionSelector = app.selectors.singleOptionSelector;
      var currentOptions = [];
      var $container = event ? $(event.currentTarget).closest(app.selectors.productForm) : $(app.selectors.productForm);

      $.map($(singleOptionSelector, $container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            currentOptions.push(currentOption);
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          currentOptions.push(currentOption);
        }
      });

      return currentOptions;
    },


    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions(event) {
      var selectedValues = app._getCurrentOptions(event);
      var variants = void 0;
      var found = false;

      if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        variants = product.variants;
      } else if (app.currentTemplate === 'product') {
        // product
        variants = app.product.variants;
      }

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },


    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newUrl = void 0;

      var showReviewForm = app._getUrlParameter('showReviewForm');
      var googlequeryParam = app._getUrlParameter('gclid'); // to track google ads

      if (window.location.search.indexOf('variant=') === -1) {
        // onload
        if (window.location.search.length) {
          newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id + "&" + window.location.search.split('?')[1];
        } else {
          newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
        }
      } else {
        newUrl = app._updateQueryStringParameter(window.location.href, "variant", variant.id);
      }

      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
    },
    _updateQueryStringParameter: function _updateQueryStringParameter(uri, key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf('?') !== -1 ? "&" : "?";
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
      } else {
        return uri + separator + key + "=" + value;
      }
    },


    /**
     * Find variant image and scroll to this image
     * works for all product page templates
     * can be extended to update all images upon variant selection
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateImages: function _updateImages(variant, event) {
      var variantImage = variant.featured_image || {};
      var variantTitle = variant.title;
      var $container = void 0;
      var currentVariantImage = void 0;

      if (app.currentTemplate === 'collection') {
        $container = $(event.currentTarget).closest(app.selectors.productForm);
        var productId = $container.data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        if (product.current_variant.featured_image) {
          currentVariantImage = product.current_variant.featured_image.src || {};
        } else {
          currentVariantImage = product.featured_image || {};
        }
      } else if (app.currentTemplate === 'product') {
        $container = $('[data-template="product"]');
        currentVariantImage = app.currentVariant.featured_image || {};
      }

      var $carousel = $container.find('[data-carousel-main]');

      if (variantImage.src === currentVariantImage.src) {
        return;
      }
      if ($carousel.length > 0) {
        if (event == undefined) {
          // on load
          setTimeout(function () {
            var flkty = Flickity.data($carousel[0]);
            if (typeof flkty === 'undefined') {
              return;
            }
            var cellElements = flkty.getCellElements();
            cellElements.forEach(function (element, index) {
              var imgAlt = $(element).data('variant-title').toLowerCase();
              //const variant_splitTitle = variantTitle.toLowerCase().split(' (');
              if (variantTitle == imgAlt) {
                flkty.selectCell(index, true, false); // value, isWrapped, isInstant
              }
            });
          }, 500);
        } else {
          // on change
          var flkty = Flickity.data($carousel[0]);
          if (typeof flkty === 'undefined') {
            return;
          }
          var cellElements = flkty.getCellElements();
          cellElements.forEach(function (element, index) {
            var imgAlt = $(element).data('variant-title');
            //const variant_splitTitle = variantTitle.toLowerCase().split(' (');
            if (variantTitle == imgAlt) {
              flkty.selectCell(index, true, false); // value, isWrapped, isInstant
            }
          });
        }
      }
    },


    /**
     * Mobile toolbar - product form - options
     */
    _toggleProductToolbarMobile: function _toggleProductToolbarMobile() {
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      app.isProductToolbarMobileOpen = !app.isProductToolbarMobileOpen;
      $productToolbarMobile.toggleClass('fully-opened');
    },
    _getActiveSubscription: function _getActiveSubscription(event) {
      var freq = $(event.currentTarget).find('option:selected').val();
      var bodyFormData = new FormData();
      bodyFormData.append('recharge_customer_id', app.rechargeData.rechargecustomerID);
      bodyFormData.append('charge_interval_frequency', freq);
      bodyFormData.append('shopify_variant_id', app.currentVariant.id);
      $('.cart-wrap button').prop('disabled', true);
      // eslint-disable-next-line promise/catch-or-return
      axios({
        method: 'post',
        url: 'https://scripts.doggielawn.com/Doggielawn/get_active_subscription.php',
        data: bodyFormData,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        // handle success
        $('.cart-wrap button').prop('disabled', false);
        // eslint-disable-next-line promise/always-return
        if (response.data.message === 'Active Subscription Found Successfully.') {
          $('.cart-wrap button').text('Add Subscription');
          app.currentActiveSubscription = response.data.data;
        } else {
          $('.cart-wrap button').text('Add to Cart');
          app.currentActiveSubscription = null;
        }
      }).catch(function (response) {
        // handle error
        console.log(response);
      });
    },
    _clubtoSubscription: function _clubtoSubscription(event) {
      app.isLoading = true;
      app.loadingEvent = 'clubSubscription';
      var qty = $(event.currentTarget).closest('form').find('[data-qty-input]').val();
      var Price = app.currentVariant.price;
      var prdImg = void 0;
      if (app.currentVariant.featured_image != null) {
        prdImg = app.currentVariant.featured_image.src;
      } else if (app.product.featured_image != null) {
        prdImg = app.product.featured_image;
      } else {
        prdImg = {};
      }
      var subFormData = new FormData();
      subFormData.append('recharge_customer_id', app.rechargeData.rechargecustomerID);
      subFormData.append('subscription_id', app.currentActiveSubscription.id);
      subFormData.append('shopify_product_id', app.product.id);
      subFormData.append('shopify_variant_id', app.currentVariant.id);
      subFormData.append('quantity', qty);
      subFormData.append('price', Price);
      subFormData.append('product_property_image', prdImg);
      axios({
        method: 'post',
        url: 'https://scripts.doggielawn.com/Doggielawn/recreate_subscription.php',
        data: subFormData,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        // handle success
        console.log(response);
        app.isLoading = false;
        app.loadingEvent = null;
        $('[data-club-subscription]').hide();
        $('[data-after-club]').show();
      }).catch(function (response) {
        // handle error
        console.log(response);
        app.isLoading = false;
        app.loadingEvent = null;
      });
    }
  }
};

export default productMethods;